
<template>
  <div id="content"  v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
        <a v-if="$_deleteActionAllowed && entity.custom_group" class="btn btn_action btn_delete" :title="'Smazat' | translate"
           @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
      </p>
        <h1>{{ translatedName }}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
            <thematic-group-basic-form
                :entity="entity"
                :is-editable="editable"
                ref="streamprofileformref"
            ></thematic-group-basic-form>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     v-if="editable"
                     :class="['btn']"
                     @click.prevent.stop="submitForm()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import thematicGroups from "./mixins/thematicGroups";
import detailActions from "../../../components/mixins/detail-actions"
import ThematicGroupBasicForm from "./forms/ThematicGroupBasicForm.vue";
import { iso6391ToIso6392 } from "../../../utils/helpers";

export default {
  name: "ThematicGroupsDetail",
  components: {ThematicGroupBasicForm},
  mixins: [detailActions, thematicGroups],
  data() {
    return {
      entityName: "thematic_group"
    }
  },
  created(ThematicGroupService, OperatorService) {
    this.entityService = ThematicGroupService
    this.operatorService = OperatorService
    this.getOperators(true);
    this.createdInit().then(()=>{
      if(this.$_loggedUser_selectedOperatorId){
        this.entity.id_operator = this.$_loggedUser_selectedOperatorId;
      }
    })
  },
  computed: {
    editable() {
      this.entity.id_operator = this.$_loggedUser_selectedOperatorId;
      return this.$_updateActionAllowed;
    },
    translatedName() {
      const language = iso6391ToIso6392(this.$language.current.toLowerCase())
      return this.entity.translations && this.entity.translations[language]
          ? this.entity.translations[language]
          : this.entity.name
    },
  },
  methods: {
    _beforeUpdateEntityActions(params = null) {
      params['id_operator'] = this.$_loggedUser_selectedOperatorId;
      return params
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/ThematicGroupDetail.vue